module.exports = __webpack_public_path__ + "img/177.d2d87993.jpg";